import React, { useMemo, useRef, useState, useEffect } from "react";

const VISIBLE = 7; // після 7 показуємо стрілки

function SegmentsTabs({
  segments,
  activetab,
  selectSegment,
  editingId,
  changeName,
  finishEdit,
  startEdit,
  deleteSegment,
  // сюди підставиш свої SVG як компоненти або просто вставиш <svg>...
  LeftIcon,
  RightIcon,
}) {
  const scrollRef = useRef(null);

  const filtered = useMemo(
    () => segments.filter(seg => seg.name !== "Additional" && seg.name !== "General"),
    [segments]
  );

  const showArrows = filtered.length > VISIBLE;

  const [canLeft, setCanLeft] = useState(false);
  const [canRight, setCanRight] = useState(false);

  const updateArrows = () => {
    const el = scrollRef.current;
    if (!el) return;
    const maxScroll = el.scrollWidth - el.clientWidth;
    setCanLeft(el.scrollLeft > 0);
    setCanRight(el.scrollLeft < maxScroll - 1);
  };

  useEffect(() => {
    updateArrows();
    const el = scrollRef.current;
    if (!el) return;

    const onScroll = () => updateArrows();
    el.addEventListener("scroll", onScroll, { passive: true });

    // на ресайз теж корисно
    const onResize = () => updateArrows();
    window.addEventListener("resize", onResize);

    return () => {
      el.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
    };
  }, [filtered.length]);

  const scrollByTabs = (dir) => {
    const el = scrollRef.current;
    if (!el) return;

    // скролимо приблизно на ширину 3 табів (можеш підкрутити)
    const amount = Math.max(200, el.clientWidth * 0.6);
    el.scrollBy({ left: dir * amount, behavior: "smooth" });
  };

  // щоб при виборі активного таба він автоматично “влазив” у вікно
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const active = el.querySelector(`[data-seg-id="${activetab}"]`);
    if (active && typeof active.scrollIntoView === "function") {
      active.scrollIntoView({ behavior: "smooth", inline: "nearest", block: "nearest" });
    }
  }, [activetab]);

  return (
    <div className="segmentsSliderWrap">
      {showArrows && (
        <button
          type="button"
          className={`segArrow left ${canLeft ? "" : "disabled"}`}
          onClick={() => scrollByTabs(-1)}
          disabled={!canLeft}
        >
          {LeftIcon ? <LeftIcon /> : "◀"}
        </button>
      )}

      <div
        ref={scrollRef}
        className={`segmentsSlider ${showArrows ? "withArrows" : ""}`}
      >
        {filtered.map((seg, i) => (
          <div
            key={seg.id}
            data-seg-id={seg.id}
            className={
              activetab === seg.id
                ? "tab_line_addish tab_line_addish_sec active"
                : "tab_line_addish tab_line_addish_sec"
            }
            onClick={() => selectSegment(seg.id)}
          >
            {editingId === seg.id ? (
              <input
                value={seg.name}
                autoFocus
                onChange={(e) => changeName(seg.id, e.target.value)}
                onBlur={() => finishEdit(seg.id)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") finishEdit(seg.id);
                }}
              />
            ) : (
              <span>{seg.name}</span>
            )}

            {activetab === seg.id ? (
              <div>
                {/* edit icon */}
                <svg
                  width="12" height="12" viewBox="0 0 12 12" fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={(e) => { e.stopPropagation(); startEdit(seg.id); }}
                  style={{ cursor: "pointer" }}
                >
                  <g clipPath="url(#clip0_6587_96749)">
                    <path
                      d="M7.85383 2.23862L9.76194 4.14673M6.58175 11.1431H11.67M1.49346 8.59899L0.857422 11.1431L3.40157 10.5071L10.7707 3.13798C11.0092 2.89943 11.1431 2.57593 11.1431 2.23862C11.1431 1.90131 11.0092 1.57782 10.7707 1.33927L10.6613 1.22987C10.4227 0.991391 10.0992 0.857422 9.76194 0.857422C9.42463 0.857422 9.10113 0.991391 8.86258 1.22987L1.49346 8.59899Z"
                      stroke="black" strokeWidth="0.5" strokeLinecap="round" strokeLinejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_6587_96749">
                      <rect width="12" height="12" fill="white" />
                    </clipPath>
                  </defs>
                </svg>

                {/* delete icon */}
                <svg
                  width="16" height="16" viewBox="0 0 16 16" fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={(e) => { e.stopPropagation(); deleteSegment(seg.id); }}
                  style={{ cursor: "pointer" }}
                >
                  <path d="M11.584 4.48535L4.6136 11.6557" stroke="black" strokeLinecap="round" />
                  <path d="M4.51367 4.58496L11.684 11.5553" stroke="black" strokeLinecap="round" />
                </svg>
              </div>
            ) : null}
          </div>
        ))}
      </div>

      {showArrows && (
        <button
          type="button"
          className={`segArrow right ${canRight ? "" : "disabled"}`}
          onClick={() => scrollByTabs(1)}
          disabled={!canRight}
        >
          {RightIcon ? <RightIcon /> : "▶"}
        </button>
      )}
    </div>
  );
}

export default SegmentsTabs;